import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { routes } from "./routers/index";

import PrivateRoute from "./layout/auth/PrivateRoute";
import { Roles } from "./constants";

export interface RouteType {
  path: string;
  component: React.FC;
  children?: RouteType[];
  protected: boolean;
  rolesRequired?: string[];
  withMainLayout?: boolean;
  /** When true, this protected route uses its path as-is (no /:currentService prefix). */
  isGlobal?: boolean;
}

const AppRoutes: React.FC = () => {
  const renderRoutes = (routes: RouteType[]) => {
    return routes.map((route, index) => {
      const RouteElement = route.protected ? (
        <PrivateRoute
          withMainLayout={route.withMainLayout}
          role={route.rolesRequired}
        >
          <route.component />
        </PrivateRoute>
      ) : (
        <route.component />
      );

      return (
        <Route
          key={`route-${index}`}
        path={
          route.protected && !route.isGlobal
            ? `/:currentService${route.path}/`
            : route.path
        }
          element={RouteElement}
        >
          {route.children && renderRoutes(route.children)}
        </Route>
      );
    });
  };

  return (
    <div className="app-container">
      <Routes>
        {renderRoutes(routes)}
        <Route path="/" element={<Navigate to="/login/" replace />} />
        <Route
          path="*"
          element={<h1 className="text-center py-5">Page not found!</h1>} // TODO: Update the 404 page
        />
      </Routes>
    </div>
  );
};

export default AppRoutes;
